(function ($) {

  // Language Switcher.
  Drupal.behaviors.language_switcher = {
    attach: function (context, settings) {
      once("language-switcher", ".language-switcher__text", context).forEach(function (el) {
        el.addEventListener("click", function (event) {
          el.classList.toggle("is-active");
          document.body.classList.toggle("is-language-switcher-expanded");
          event.preventDefault();
        });
      });
    },
  };

  // Colorbox inline.
  Drupal.behaviors.colorbox_inline = {
    attach: function (context) {
      $('.colorbox-inline', context).colorbox({
        inline: true,
        transition: "none",
        fadeOut: 0,
        maxWidth: '80%',
        onComplete: function () {
          $(this).colorbox.resize();
        }
      });
    },
  };

  // Colorbox for YouTube.
  Drupal.behaviors.colorboxYouTube = {
    attach: function (context) {
      $('.colorbox-youtube', context).colorbox({
        iframe: true,
        innerWidth: 950,
        innerHeight: 540,
        maxWidth: '95%',
        href: function() {
          var videoId = new RegExp('[\\?&]v=([^&#]*)').exec(this.href);
          if (videoId && videoId[1]) {
            return 'https://youtube.com/embed/'+videoId[1]+'?rel=0&wmode=transparent&autoplay=1';
          }
        }
      });
    }
  };

  // Anchor Links.
  Drupal.behaviors.anchor_links = {
    attach: function (context, settings) {
      const anchorItem = $('.anchor-links-content__item', context);
      const anchorLinkButton = $('.anchor-links-content__item__toggle', context);
      const anchorItemContent = $('.anchor-links-content__item__content', context);

      // Set active class of first item with title.
      $('.anchor-links-content__item.with-title:first', context).addClass('is-active');

      // Click on a question and show the answer.
      anchorLinkButton.click(function() {
        if ($(this).parent().hasClass('is-active')) {
          $(this).removeClass('is-active');
          anchorItemContent.slideUp();
          anchorItem.removeClass('is-active');
        } else {
          anchorItemContent.slideUp();
          $(this).siblings().slideDown();
          anchorItem.removeClass('is-active');
          $(this).parent().addClass('is-active');
        }
      });
    },
  };

  // Mobile navigation submenu expanding functionality.
  Drupal.behaviors.mobile_menu = {
    attach: function (context, settings) {
      const mainNav = $('#block-mainnavigation, #block-mainnavigationhomepage', context);
      var width = $(window).width();

      const menuItemExpanded = $('.menu--main .menu-level-0 > .menu-item--expanded > a', context);
      menuItemExpanded.after('<button class="menu-item__plus"></button>');

      // Open/close submenus.
      $('.menu-level-0 > .menu-item--expanded .menu-item__plus').click(function (e) {
        $(this).toggleClass('is-open')
        .siblings('.menu-dropdown').toggleClass('is-open');
        e.preventDefault()
      })
    },
  };

  $(document).ready(function () {
    // Inclusive tile clicks
    // https://inclusive-components.design/cards/
    var tiles = document.querySelectorAll(".tile-js");
    Array.prototype.forEach.call(tiles, function (tile) {
      var down,
        up,
        link = tile.querySelector("h4 a");
      tile.style.cursor = "pointer";
      tile.onmousedown = function () {
        return (down = +new Date());
      };
      tile.onmouseup = function () {
        up = +new Date();
        if (up - down < 200) {
          link.click();
        }
      };
    });

    $("video").click(function () {
      var video = $(this)[0];
      if (video.paused) {
        video.play();
        $(this).parent().addClass("playing");
      } else {
        video.pause();
        $(this).parent().removeClass("playing");
      }
    });

    AOS.init();

    if (!Modernizr.touch) {
      // Paragraph parallax images
      paraxify(".paraxify", {
        speed: 0,
        boost: 0,
      });
    }

    // Hero image curve scrolling affect
    MorphSVGPlugin.convertToPath("#start, #end");
    var controller = new ScrollMagic.Controller();
    var tween = gsap.to("#start", 1, {
      morphSVG: "#end",
      ease: Linear.easeNone,
    });
    var controller = new ScrollMagic.Controller();
    var scene = new ScrollMagic.Scene({
      triggerElement: ".hero",
      duration: 400,
      offset: -200,
    })
      // .addIndicators()
      .setTween(tween)
      .addTo(controller);
    // get the current triggerHook value
    var triggerHook = scene.triggerHook();
    // set a new triggerHook using a string
    scene.triggerHook("onLeave");
    // set a new triggerHook using a number
    scene.triggerHook(-0.5);

    // Slider component
    $(".image-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      autoplay: true,
      asNavFor: ".image-slider__nav",
    });
    // Slider component thumbs
    $(".image-slider__nav").slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      asNavFor: ".image-slider",
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1080,
          settings: {
            slidesToShow: 6,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 5,
          },
        },
      ],
    });
  });

})(jQuery);
